import { updatePlantActive } from '@apis';
import { useMutation } from '@tanstack/react-query';
import usePlantQueryInvalidation from './usePlantQueryInvalidation';

type UpdatePlantActiveVariables = {
  plantId: string;
  isActive: boolean;
};

const useUpdatePlantActive = () => {
  const { invalidatePlantList } = usePlantQueryInvalidation();
  const { invalidatePlantDetail } = usePlantQueryInvalidation();

  return useMutation({
    mutationFn: async ({ plantId, isActive }: UpdatePlantActiveVariables) => {
      const response = await updatePlantActive(plantId, isActive)

      if (response.codeHTTP !== 200) {
        throw new Error('Failed to save plant status.');
      }

      await invalidatePlantList();
      await invalidatePlantDetail(plantId);

      return response;
    },
  });
};

export default useUpdatePlantActive;
